import { useFormContext } from "react-hook-form";

import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepFeedback } from "../components/step-feedback";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";

export default function UpdatePreference() {
  const { t } = useTranslation();
  const choices = [
    {
      label: t("REGULAR_CHECK_IN"),
      value: "Regular check-ins",
      feedback: t("REGULAR_CHECK_IN_FEEDBACK"),
    },
    {
      label: t("KEY_MILESTONE_UPDATES"),
      value: "Key milestone updates",
      feedback: t("KEY_MILESTONE_UPDATES_FEEDBACK"),
    },
    {
      label: t("ONLY_WHEN_NECESSARY"),
      value: "Only when necessary",
      feedback: t("ONLY_WHEN_NECESSARY_FEEDBACK"),
    },
  ];

  const { watch } = useFormContext();
  const communicationPreference = watch(funnelInputsNameMap.updatePreference);
  const feedback = communicationPreference
    ? choices.find(({ value }) => value === communicationPreference)?.feedback
    : "";

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_UPDATE_PREFERENCE_TITLE")}</StepTitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.updatePreference}
            choices={choices}
            required
          />
          <StepFeedback>{feedback}</StepFeedback>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
